import { CollectionModel } from 'common/api/models';
import { COLLECTION_IS_LOADING, COLLECTION_RESET, COLLECTION_SET_IN_STORE } from 'common/actions';

const initialState = { ...CollectionModel({}), isLoading: false };

export const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case COLLECTION_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case COLLECTION_SET_IN_STORE:
      return { ...action.payload.collection, isLoading: false };

    case COLLECTION_RESET:
      return initialState;

    default:
      return state;
  }
};
